import { render, staticRenderFns } from "./ChouLayout.vue?vue&type=template&id=850d6500&scoped=true&"
import script from "./ChouLayout.vue?vue&type=script&lang=js&"
export * from "./ChouLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChouLayout.vue?vue&type=style&index=0&id=850d6500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850d6500",
  null
  
)

export default component.exports